export function SeverityBadge({ band, size = "md" }) {
  if (!band) return null;
  const cls = `band-${band}`;
  const sizeCls = size === "lg" ? "text-sm px-4 py-1.5" : "text-xs px-3 py-1";
  return (
    <span
      data-testid={`severity-badge-${band}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${sizeCls} ${cls}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full band-dot-${band}`} />
      {band[0].toUpperCase() + band.slice(1)}
    </span>
  );
}

/**
 * Return {title, body} for a given severity band, translated to the given
 * `t()` function's locale. Passing no `t` falls back to English.
 */
export function bandCopy(band, t) {
  if (!band) return { title: "", body: "" };
  const tr = typeof t === "function" ? t : (k) => k;
  return {
    title: tr(`band.${band}.title`),
    body: tr(`band.${band}.body`),
  };
}
